// import React, { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useMsal } from "@azure/msal-react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import AdministrationTab from "../../components/Admin/AdministrationTab/AdministrationTab";
 
 
const AdministrationPage: React.FC = () => {
    return (
      <div className="flex flex-col min-h-screen bg-[#F7F7FF]">
      <div className="flex-grow">
        <Header/>
       
        <main>
          <AdministrationTab/>
        </main>
        </div>
        <Footer />
       
      </div>
    );
  };
 
  export default AdministrationPage;